export class UsuarioWebDTOModel {

    constructor(
        public cdCentrus?: string,
        public cdCentrusTit?: string,
        public sgSenha?: string,
        public nrMatricula?: string,
        public stUsuario?: string,
        public dtExpSenha?: string,
        public dhUltAcesso?: string,
        public idUsuario?: string,
        public tpOrigemFunc?: string
    ) {
    }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/models/usuarioWebDTO.model.ts